import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import MainNav from 'core/containers/main-nav-container';
import LogoHeader from 'core/containers/logo-header-container';
import Footer from 'core/containers/footer-container';
import classes from './core-view.scss';
import 'styles/core.scss';
import AlertAuthWarning from 'containers/alert-auth-warning-container';
import AlertAuthExpired from 'containers/alert-auth-expired-container';
import MessageBanner from 'containers/message-banner-container';
import { injectIntl, defineMessages} from 'react-intl';
import mt from 'core/message-translations';
import Unauthorized from 'routes/unauthorized/containers/unauthorized-container';
import ErrorView from 'routes/error/containers/error-container';
import PersonalInfo from 'routes/personal-info/containers/personal-info-container';
import SigninSecurity from 'routes/signin-security/containers/signin-security-container';
import UserInvitation from 'routes/user-invite/containers/user-invitation-container';
import AcceptInvitation from 'routes/accept-invitation/containers/accept-invitation-container';
import {
  showToastrMessage,
  isUserInvitationPage,
} from 'lib/utility-functions';
import environment from "lib/environment";
import auth from 'lib/profile-auth';
import history from "lib/history";
import resolveRoute from "lib/resolve-route";
import ConfirmDialog from 'containers/confirm-dialog-container';

const t = defineMessages({
  'core.skip.to.main.content': {
    id: 'core.skip.to.main.content',
    defaultMessage: 'Skip to main content',
    description: 'Skip link to main content to bypass navigation links for better accessibility',
  },
});

const Core = (props) => {
  /* istanbul ignore next */
  if(isUserInvitationPage()) {
    const urlParams = new URLSearchParams(window.location.search);
    if(!urlParams.get('id')) {
      window.location.href = `${environment.get().myAccount_url}`;
      return null;
    }
    if(auth.auth && urlParams.get('id')) {
      history.push(resolveRoute('acceptInvitation', {search: `?id=${urlParams.get('id')}`}));
      return null;
    }
  }
  return (
    <div
      className="app-container"
      id="app-container">
      {props.toastrMessage &&
        props.toastrMessage.type &&
        props.toastrMessage.messageId &&
        showToastrMessage(
          props.toastrMessage.type,
          props.intl.formatMessage(mt[props.toastrMessage.messageId],
            props.toastrMessage.params)
        )}
      {
        props.confirmDialog &&
        props.confirmDialog.yesCallbackFn &&
        props.confirmDialog.noCallbackFn &&
          <ConfirmDialog />
      }
      <div className="app-container-inner">
        <div className={classes['skipToMainContent']}>
          <a href="#mainContent">
            {props.intl.formatMessage(t['core.skip.to.main.content'])}
          </a>
        </div>
        {props.useStandardNav &&
          <MainNav />}
        {!props.useStandardNav &&
          <LogoHeader />}
        {props.alertAuthWarningIsVisible &&
          <AlertAuthWarning />}
        {props.alertAuthExpiredIsVisible &&
          <AlertAuthExpired />}
        {props.messageBannerVisible &&
          <MessageBanner />}
        <div className="container-fluid navbar-gray-background" />
        <div className="container-fluid">
          <div
            className="app-content text-center"
            id="mainContent">
            <div className={classes.mainContainer}>
              <Switch>
                <Redirect
                  exact
                  from="/"
                  to="/personal-info"
                />
                <Route
                  exact
                  path="/personal-info"
                  component={PersonalInfo}
                />
                <Route
                  exact
                  path="/signin-security"
                  component={SigninSecurity}
                />
                <Route
                  exact
                  path="/userinvitation"
                  component={UserInvitation}
                />
                <Route
                  exact
                  path="/acceptinvitation"
                  component={AcceptInvitation}
                />
                <Route
                  exact
                  path="/unauthorized"
                  component={Unauthorized}
                />
                <Route
                  exact
                  path="/error"
                  component={ErrorView}
                />
              </Switch>
            </div>
            <div className="footerSpacer" />
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

Core.propTypes = {
  intl: PropTypes.object.isRequired,
  alertAuthWarningIsVisible: PropTypes.bool,
  alertAuthExpiredIsVisible: PropTypes.bool,
  messageBannerVisible: PropTypes.bool,
  useStandardNav: PropTypes.bool.isRequired,
  toastrMessage: PropTypes.shape({
    type: PropTypes.string,
    messageId: PropTypes.string,
    params: PropTypes.object,
  }),
  confirmDialog: PropTypes.shape({
    yesCallbackFn: PropTypes.func,
    noCallbackFn: PropTypes.func,
  }),
};

export default withRouter(injectIntl(Core));
